import { render, staticRenderFns } from "./usPowerBall.vue?vue&type=template&id=a046da32&scoped=true"
var script = {}
import style0 from "./usPowerBall.vue?vue&type=style&index=0&id=a046da32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a046da32",
  null
  
)

export default component.exports